<ui-icon faName="user-hat-tie" faStyle="light"></ui-icon>
<span>{{ currentUser().id }}</span>
<span>{{ currentUser().mail }}</span>
<ui-icon matRipple class="settings" faName="gear" faStyle="light" (click)="openSettings.emit()"></ui-icon>
